import TheGrid from '@/views/dealers/teams-new/grid'
import TheGridManagers from '@/views/dealers/teams-new/gridmanagers'
import Edit from '@/views/dealers/teams-new/edit'

export default {
  path: '/dealers/teams-new',
  redirect: '/dealers/teams-new/index',
  name: 'teams-new',
  meta: {
    auth: {
      redirect: {
        name: 'teams-new.index'
      },
      forbiddenRedirect: '/dashboard'
    },
    label: 'Equipas'
  },
  component: {
    render(c) {
      return c('router-view')
    }
  },
  children: [{
    path: 'index',
    name: 'teams-new.index',
    component: TheGrid,
    meta: {
      auth: true,
      roles: ['SUPER','UFS'],
      forbiddenRedirect: '/dashboard',
      label: 'Lista'
    }
  }, {
    path: 'managers',
    name: 'teams-new.managers',
    component: TheGridManagers,
    meta: {
      auth: true,
      roles: ['SUPER','UFS'],
      forbiddenRedirect: '/dashboard',
      label: 'Criar'
    }
  }, {
    path: 'create',
    name: 'teams-new.create',
    component: Edit,
    meta: {
      auth: true,
      roles: ['SUPER','UFS'],
      forbiddenRedirect: '/dashboard',
      label: 'Criar'
    }
  }, {
    path: 'edit/:id',
    name: 'teams-new.edit',
    component: Edit,
    meta: {
      auth: true,
      roles: ['SUPER','UFS'],
      forbiddenRedirect: '/dashboard',
      label: 'Editar'
    }
  }]
}
